import { prop } from 'ramda';
import { useCallback } from 'react';
import { dispatcher } from 'dispatcher';
import { useDispatch } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { useAppSelector } from '@core/js/store/hooks';
import { userSetAttributesAction } from '@core/js/hooks/user/store/actions';
import { pushDispatcher } from '@core/js/hooks/socket/hooks/usePushSubscription';
import { storageService } from '@core/js/services/storage.service';
import {
    useFetchBalance,
    useFetchUserDetails,
    useGetUserUrlTemplates
} from '@core/js/hooks/user';
import { setUserIBAN } from '@theme/js/hooks/usePublicAPI/hooks/useServerPublicAPI/server';

/* TotalCasino changes */
const setAccountNumber = (res) => {
    if (storageService.local.getItem('isAfterRegistration')) {
        setUserIBAN({
            specificParams: {
                field1: res.iban?.slice(2)
            }
        });
    }
};
/* TotalCasino changes */

export const useAfterLoginAction = () => {
    const verifyJumio = useVerifyJumio();
    const getUrlTemplates = useGetUserUrlTemplates();
    const fetchUserDetails = useFetchUserDetails();
    const fetchBalance = useFetchBalance();

    return useCallback(() => Promise.all([
        /* TotalCasino changes */
        fetchUserDetails().then((res) => {
            setAccountNumber(res);
            verifyJumio(res.suspended, res.ageVerificationStatus);
        }),
        /* TotalCasino changes */
        getUrlTemplates(),
        fetchBalance(),
        setAccountNumber
    ]), [
        fetchUserDetails,
        verifyJumio,
        getUrlTemplates,
        fetchBalance
    ]);
};

export const useVerifyJumio = () => {
    const location = useLocation();
    const dispatch = useDispatch();
    const netVerifyJumioEnabled = useAppSelector(prop('netVerifyJumioEnabled'));

    return useCallback(({ suspended, ageVerificationStatus }) => {
        const params = new URLSearchParams(location.search);
        const isHideKYC = params.get('hideKYC') === '1';
        const isUserSuspended = suspended === 'true';
        const isJumioAllowed = netVerifyJumioEnabled && ageVerificationStatus === 'inprocess';

        if (isJumioAllowed && !isHideKYC) {
            dispatch(userSetAttributesAction({ suspended: isUserSuspended }));

            pushDispatcher.trigger('userVerify', isUserSuspended);

            if (isUserSuspended) {
                dispatcher.dispatch('auth:suspend', true);

                return Promise.reject(false);
            }

            dispatcher.dispatch('auth:suspend', false);
        }

        return true;
    }, [location, netVerifyJumioEnabled, dispatch]);
};
